import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRewrite1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRewrite1"><Path d="M8 4.5H2.5V19.5H11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16 19.5H21.5V4.5H12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 10.5H15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 13.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 2.5L8.5 4.5L6.5 6.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 17.5L15.5 19.5L17.5 21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRewrite1;
